<script>
    import { mapState } from 'vuex';

    export default {
        name: "ElementFactory",
        computed: {
            ...mapState('elements',[
                'elementTypesMapping'
            ]),
            elementNameForType () {
                return this.envNamePrefix + this.elementTypesMapping[this.registrationData.elementType] + "Element";
            },
        },
        props: {
            registrationData: {
                type: Object,
                required: true
            }
        },

    }
</script>
